// Stored order.total is the grand total, including delivery. Never add the fee twice.
export const money = value => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.round((parsed + Number.EPSILON) * 100) / 100 : 0;
};

export const calculateOrderTotal = (items = [], deliveryFee = 0) => money(
  items.reduce((sum, item) => sum + money(item?.price), 0) + money(deliveryFee)
);

export const getReceiptAmounts = (order = {}) => {
  const total = money(order.total);
  const deliveryFee = money(order.deliveryFee);
  const balance = money(order.balance);
  return { total, deliveryFee, subtotal: money(total - deliveryFee), balance, paid: money(total - balance) };
};

export const calculateBalance = ({ total, payment, amountReceived }) => {
  if (payment === 'Fully Paid') return 0;
  const received = amountReceived === '' || amountReceived == null ? money(total) / 2 : money(amountReceived);
  return money(Math.max(0, money(total) - received));
};

export const applyPayment = (order, amount) => {
  const balance = money(order.balance);
  const paid = money(amount);
  if (!Number.isFinite(Number(amount)) || paid <= 0 || paid > balance) {
    throw new Error('Payment must be positive and cannot exceed the remaining balance.');
  }
  const newBalance = money(balance - paid);
  return {
    balance: newBalance,
    payment: newBalance === 0 ? 'Fully Paid' : 'Downpayment',
    amountReceived: money(money(order.total) - newBalance),
    previousBalance: order.balance,
    previousPayment: order.payment
  };
};

export const buildExpense = (amount, description, category = 'Supplies & Packaging') => {
  // Reject malformed inputs instead of converting an object/blank string into NaN or zero.
  if ((typeof amount !== 'number' && typeof amount !== 'string') ||
      String(amount).trim() === '' || !Number.isFinite(Number(amount)) || money(amount) <= 0) {
    throw new Error('Enter a valid expense amount greater than zero.');
  }
  if (typeof description !== 'string' || !description.trim()) {
    throw new Error('Enter an expense description.');
  }
  return { amount: money(amount), description: description.trim(), category, date: new Date().toISOString() };
};
